// Filename - pages/maker.js

import React from "react";
import MyHeader from "../components/headerComponent.js";
import Navbar from "../components/nav.js";
import Blogs from "../components/blogsComponent.js";
import SocialsBar from "../components/socialsBar.js";
import MyFooter from "../components/footerComponent.js";

const Maker = () => {
	return (
		<div className="Blog">
            <header>
                <MyHeader />
                <Navbar />
            </header>
            <main>
                <h2>  Blog </h2>
                <Blogs />
            </main>
            <footer>
                <SocialsBar />
                <MyFooter />
            </footer>
		</div>
	);
};

export default Maker;